import { focusableSelectors } from "@utils/accessibility/menu";

const EVENT_LISTENER_ATTR = 'data-focus-trap-attached';

function trapFocus(container: HTMLElement) {
    if (container.hasAttribute(EVENT_LISTENER_ATTR)) return;
    container.setAttribute(EVENT_LISTENER_ATTR, 'true');

    const getFocusable = (): HTMLElement[] =>
        Array.from(container.querySelectorAll<HTMLElement>(focusableSelectors))
            .filter(el => el.offsetParent !== null); // only visible ones

    container.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key !== 'Tab') return;

        const focusableElements = getFocusable();
        if (focusableElements.length === 0) return;

        const firstEl = focusableElements[0];
        const lastEl = focusableElements[focusableElements.length - 1];
        const activeEl = document.activeElement as HTMLElement;

        if (e.shiftKey) {
            // Shift + Tab
            if (activeEl === firstEl || !container.contains(activeEl)) {
                e.preventDefault();
                lastEl.focus();
            }
        } else {
            // Tab
            if (activeEl === lastEl || !container.contains(activeEl)) {
                e.preventDefault();
                firstEl.focus();
            }
        }
    });
}

export function setupFocusTraps() {
    const traps = document.querySelectorAll<HTMLElement>('.focus-trap');
    traps.forEach(trapFocus);
}
